import { render } from "./TravelPassYoungAdultDetails.vue?vue&type=template&id=e657827a&scoped=true&lang=pug"
import script from "./TravelPassYoungAdultDetails.vue?vue&type=script&lang=ts"
export * from "./TravelPassYoungAdultDetails.vue?vue&type=script&lang=ts"

import "./TravelPassYoungAdultDetails.vue?vue&type=style&index=0&id=e657827a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e657827a"

export default script